import React, { useState, useEffect, useRef, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { Tooltip } from '@progress/kendo-react-tooltip'
import {
  InformationADAkubicaFirmaDigitalInvitedPure,
  PromotionalFooterPure,
  GridHLPure,
  DialogSystemGLPure,
  SubtitleCustom,
  ButtonHLPure,
  DialogFormHLPure,
  GridSimpleReadHLPure,
  ValidationCodePure,
  TooltipHLPure,
  SearchBarHLPure
} from '../../pures'
import DialogDeleteSignaturePure from '../../pures/dialog-delete-signature/dialog-delete-signature.pure'
import './signature-receive-panel.css'
import CanvasDraw from 'react-canvas-draw'
import SignatureReceiveService from '../../../services/signature-receive.service'
import { SimpleLoading } from "../../pures";
import { Context } from '../../../Context'

const SignatureReceivePanelView = (props) => {
  const { stateSortStart, stateSortLimit } = props
  const { t } = useTranslation()

  const context = useContext(Context)
  const { 
    notificationFilters, 
    setSelectedFilter
  } = context

  const selectedValueFilter = notificationFilters.selectedFilter


  let edit = t('cellDetailSignatureRequest.seeDetail')
  let tooltipTracking = t('cellDetailSignatureRequest.tooltipTracking')
  let tooltipSeeDetail = t('cellDetailSignatureRequest.tooltipSeeDetail')
  let tooltipDelete = t('cellDetailSignatureRequest.tooltipCancelSignRequest')

  const [selectedItem, setSelectedItem] = useState({})
  const [selectedUser, setSelectedUser] = useState()
  const [allRequests, setAllRequests] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [requests, setRequests] = useState([])
  const pad = useRef(null)

  let infodevice = navigator.userAgent.toLowerCase()
  let isMobile = infodevice.includes('android')
  isMobile = isMobile || infodevice.includes('iphone')
  isMobile = isMobile || infodevice.includes('ipad')
  isMobile = isMobile || infodevice.includes('mobile')

  const handleSearchChange = (e) => {
    const term = e.target.value
    setSearchTerm(term)
  }

  const fetchRequests = async () => {
    try {
      setIsLoading(true)
      const tokenData = JSON.parse(localStorage.getItem('token'))
      const token = tokenData?.accessToken || tokenData?.idToken
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      const params = {
        timezone,
        token,
        solicitudeName: searchTerm || undefined
      }

      switch (selectedValueFilter) {
        case 'Pendientes':
          params.inboxInvolvedType = 'received'
          break
        case 'Canceladas':
          params.status = 'Cancelado'
          break
        case 'Rechazadas':
          params.status = 'Rechazado'
          break
        case 'En progreso':
          params.inboxInvolvedType = 'sent'
          break
      }

      const signatureReceiveService = new SignatureReceiveService(process.env.REACT_APP_MIFIRMA_API)
      const response = await signatureReceiveService.getAllInbox(params)

      const formattedRequests = (response?.data?.inboxFiltered || []).map(item => {
        const { solicitudeStartDate, solicitudeLimitDate, actionName, solicitudeStatus } = item.inbox || {}
        const formatDate = (dateStr) => {
          if (!dateStr) return ''
          const date = new Date(dateStr)
          return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`
        }

        return {
          ...item.inbox,
          solicitudeStartDate: formatDate(solicitudeStartDate),
          solicitudeLimitDate: formatDate(solicitudeLimitDate),
          actionName: t(`signatureReceivePanelView2.${actionName}`, { defaultValue: actionName }),
          solicitudeStatus: t(`signatureReceivePanelView2.inbox.solicitudeStatus.${solicitudeStatus}`, { defaultValue: solicitudeStatus })
        }
      })

      setAllRequests(formattedRequests)
    } catch (error) {
      console.error('Error fetching requests:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const filtered = allRequests.filter(req =>
      req.solicitudeName?.toLowerCase().includes(searchTerm.toLowerCase())
    )

    if (stateSortStart === 1) {
      filtered.sort((a, b) => {
        const dateA = new Date(a.solicitudeStartDate.split('/').reverse().join('-'))
        const dateB = new Date(b.solicitudeStartDate.split('/').reverse().join('-'))
        return dateB - dateA
      })
    } else if (stateSortStart === 2) {
      filtered.sort((a, b) => {
        const dateA = new Date(a.solicitudeStartDate.split('/').reverse().join('-'))
        const dateB = new Date(b.solicitudeStartDate.split('/').reverse().join('-'))
        return dateA - dateB
      })
    }

    if (stateSortLimit === 1) {
      filtered.sort((a, b) => {
        const dateA = new Date(a.solicitudeLimitDate.split('/').reverse().join('-'))
        const dateB = new Date(b.solicitudeLimitDate.split('/').reverse().join('-'))
        return dateB - dateA
      })
    } else if (stateSortLimit === 2) {
      filtered.sort((a, b) => {
        const dateA = new Date(a.solicitudeLimitDate.split('/').reverse().join('-'))
        const dateB = new Date(b.solicitudeLimitDate.split('/').reverse().join('-'))
        return dateA - dateB
      })
    }
    setRequests(filtered)
  }, [searchTerm, allRequests, stateSortStart, stateSortLimit])

  useEffect(() => {
    fetchRequests()
  }, [selectedValueFilter])

  const isTablet = useMediaQuery('(min-width: 950px) and (max-width: 1180px)')
  const showIconTracking = useMediaQuery('(max-width: 650px')
  const isSmallScreen = useMediaQuery('(max-width: 1181px)')
  const showActions = useMediaQuery('(max-width: 250px)')
  const longmatches = useMediaQuery('(max-width:900px)')
  const isDesktop = useMediaQuery('(min-width: 1181px)')

  const globalContainerStyles = {
    display: 'inline-block',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    backgroundColor: 'white',
    padding: '20px',
    height: '100%',
  }
  const containerTableAndHeadersStyles = {
    maxWidth: '100%',
    marginTop: '20px',
    justifyContent: 'start',
    paddingTop: '10px',
    backgroundColor: 'white',
  }

  const menuStatusIconStyles = {
    fontSize: '18px',
    marginRight: '9px',
  }
  const containerInformationContactPlanStyles = {
    marginTop: '10px',
    marginBottom: '20px',
  }
  const informationContactInvitedGridContainer = {
    alignItems: 'start',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff',
    marginLeft: '0px',
    marginBottom: '20px',
    boxShadow: '1px 1px 3px #959595',
    paddingLeft: '10px',
    paddingBottom: '10px',
    lineHeight: '1.1rem',
  }
  const filterContainerStyles = {
    marginTop: '7px',
    marginLeft: '75px',
  }

  const handleFilterChange = (newFilter) => {
    setSelectedFilter(newFilter)
  }

  if (longmatches) {
    filterContainerStyles.marginLeft = 0
    filterContainerStyles.marginTop = 7
  }

  return (
    <div className='standard-wrapper'>
      <Container
        spacing={4}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={globalContainerStyles}
      >
        {/* Table and Header */}

        <Grid
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className='header-inbox'>
          <SubtitleCustom
            title={t('signatureReceivePanelView.receiveRequest')}
            children={
              !props.canSignByVolume ?
                null
                : props.disabledVolumeSign ?
                  <TooltipHLPure
                    positionTooltip={'left'}
                    titleTooltip={t('signatureReceivePanel.byVolume.mainButton.title')}
                    descriptionTooltip={t('signatureReceivePanel.byVolume.mainButton.tooltip')}
                    customImg={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_multiples_firmas.svg`}
                    styleCustomImg='volumeSignIcon'
                  />
                  :
                  <img
                    onClick={!props.disabledVolumeSign ? () => props.showVolumeDialog(true) : null}
                    src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_multiples_firmas.svg`}
                    className='volumeSignIcon'
                  />
            }
          />
        </Grid>

        <div className='table-wapprer-buttons'>
          <Tooltip
            openDelay={600}
            position='top'
            anchorElement='target'
            tooltipClassName='tooltipGeneralStyle'
          >
            <button
              title={t('signatureReceivePanelView2.tooltipTabPending')}
              className={`table-filter-buttons ${selectedValueFilter === 'Pendientes' ? 'table-button-blue-active' : ''}`}
              onClick={() => handleFilterChange('Pendientes')}
            >
              <span
                className='SignatureReceivePanelView-title-filter'
                title={t('signatureReceivePanelView2.tooltipTabPending')}
              >
                {t('signatureReceivePanelView2.title.tooltip.pending')}
              </span>
            </button>
          </Tooltip>

          <Tooltip
            openDelay={600}
            position='top'
            anchorElement='target'
            tooltipClassName='tooltipGeneralStyle'
          >
            <button
              title={t('signatureReceivePanelView2.tooltipTabProcess')}
              className={`table-filter-buttons ${selectedValueFilter === 'En progreso' ? 'table-button-blue-active' : ''}`}
              onClick={() => handleFilterChange('En progreso')}
            >

              <span
                className='SignatureReceivePanelView-title-filter'
                title={t('signatureReceivePanelView2.tooltipTabProcess')}
              >
                {t('signatureReceivePanelView2.title.tooltip.process')}
              </span>
            </button>
          </Tooltip>

          {!isSmallScreen && (
            <>
              <Tooltip
                openDelay={600}
                position='top'
                anchorElement='target'
                tooltipClassName='tooltipGeneralStyle'
              >
                <button
                  title={t('signatureReceivePanelView2.tooltipCancel')}
                  className={`table-filter-buttons ${selectedValueFilter === 'Canceladas' ? 'table-button-blue-active' : ''}`}
                  onClick={() => handleFilterChange('Canceladas')}
                >
                  <span
                    className='SignatureReceivePanelView-title-filter'
                    title={t('signatureReceivePanelView2.tooltipCancel')}
                  >
                    {t('signatureReceivePanelView2.title.tooltip.cancel')}
                  </span>
                </button>
              </Tooltip>

              <Tooltip
                openDelay={600}
                position='top'
                anchorElement='target'
                tooltipClassName='tooltipGeneralStyle'
              >
                <button
                  title={t('signatureReceivePanelView2.tooltipAll')}
                  className={`table-filter-buttons ${selectedValueFilter === 'Todas' ? 'table-button-blue-active' : ''}`}
                  onClick={() => handleFilterChange('Todas')}
                >
                  <span
                    className='SignatureReceivePanelView-title-filter'
                    title={t('signatureReceivePanelView2.tooltipAll')}
                  >
                    {t('signatureReceivePanelView2.title.tooltip.all')}
                  </span>
                </button>
              </Tooltip>
            </>
          )}

          <div className='filter'>
            <SearchBarHLPure
              onSearchChange={(value) => { handleSearchChange(value) }}
              placeholder={t('digitalVaultView.title.search')}
              searchValue={searchTerm}
            />
          </div>
        </div>
        {
          isLoading ? (
            <SimpleLoading />
          ) : (
            <GridHLPure
              {...props}
              dataGrid={requests}
              skip={0}
              take={6}
              fieldSubtitle={'actionName'}
              onSelectedItem={setSelectedUser}
              selectedFilter={selectedValueFilter}
              //Primera columna
              titleRow1={t('signatureReceivePanelView2.grid.title.1')}
              fieldRow1={'solicitudeName'}
              styleCol1={'signatureReceivePanel-col1'}
              lockedColumnOne={true}
              //Segunda columna (aunque diga 3)
              columnThree={isDesktop || isTablet}
              titleRow3={t('signatureReceivePanelView2.grid.title.3')}
              fieldRow3={'solicitudeStatus'}
              styleCol2={'signatureReceivePanel-col2'}
              //Tercera columna 
              extraColumnInbox={isDesktop || isTablet}
              titleExtraColumn={t('signatureReceivePanelView2.grid.title.create.date')}
              fieldRow4={'solicitudeStartDate'}
              styleCol3={'signatureReceivePanel-col3'}
              otherExtraColumnInbox={isDesktop || isTablet}
              titleOtherExtraColumn={t('signatureReceivePanelView2.grid.title.limit.date')}
              fieldRow5={'solicitudeLimitDate'}
              featuresColumnInbox={isDesktop}
              titleFeaturesColumn={t('signatureReceivePanelView2.grid.title.characteristics')}
              fieldRow6={'solicitudeAdditionalData'}
              columnFourForInbox
              titleRow4={!showActions ? t('signatureReceivePanelView2.grid.title.actions') : ''}
              labelFourthActions={t('signatureReceivePanelView2.grid.title.detail')}
              inboxTypeCell
              styleCol4={'signatureReceivePanel-colActions'}
              widthHeaderCol4={'signatureReceivePanel-colActions'}
              stateSortStart={stateSortStart}
              stateSortLimit={stateSortLimit}
              changeSort={props.filterByState}
              tooltipDetail={tooltipSeeDetail}
              tooltipTracking={tooltipTracking}
              tooltipDelete={tooltipDelete}
              seeDetail={edit}
              labelsColumnsNoPadding
              widthHeader={'signatureReceivePanel-col1Header'}
              showTracking={showIconTracking}
              iconSubtitle
              iconField={'actionIcon'}
            />
          )
        }
        {/* Information of plan, contact and Ad */}
        {props.userType.id !==
          Number(Number(process.env.REACT_APP_USER_TYPE_INVITADO)) ? (
          <div>
            {props.userType.id ==
              Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) ? (
              <PromotionalFooterPure />
            ) : (
              <PromotionalFooterPure />
            )}
          </div>
        ) : (
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            style={containerInformationContactPlanStyles}
          >
            <Grid container xs={12} lg={12} md={12} sm={12} es={12} spacing={2}>
              <PromotionalFooterPure />
            </Grid>
            <Grid
              container
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              spacing={2}
              style={informationContactInvitedGridContainer}
            >
              <InformationADAkubicaFirmaDigitalInvitedPure
                onInvitedRedirectRegister={props.onInvitedRedirectRegister}
              />
            </Grid>
          </Container>
        )}

        {/* Dialog Delete Request */}
        <DialogDeleteSignaturePure
          {...props}
          toggleDialogDeleteRequest={props.toggleDialogDeleteRequest}
          handleCommentsDelete={props.handleCommentsDelete}
          deleteSignRequest={props.deleteSignRequest}
        />

        {/* Alerts of Notification Completed and Loadign */}
        <DialogSystemGLPure
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          showLoadingRequesting={props.showLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
          showCompletedRequesting={props.showCompletedRequesting}
          showErrorRequesting={props.showErrorRequesting}
          messageComplete={props.messageComplete}
          message={props.message}
        />

        {props.showVolumeSign &&
          <DialogFormHLPure
            titleDialog={t('signatureReceivePanel.byVolume.mainButton.title')}
            className={'dialogStyles'}
            dialogCollaboratorWidth={'50%'}
            dialogCollaboratorHeight={'50%'}
            cancel={() => {
              props.showVolumeDialog(false)
            }}
          >
            {!props.verifiedNip ?
              <>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className='signatureReceivePanel-container-volumeSign'
                >
                  <GridSimpleReadHLPure
                    customClassGrid='signatureReceivePanel-customGrid'
                    dataGrid={props.volumeSigns}
                    skip={0}
                    take={props.volumeSigns.length}
                    pageableGrid={false}
                    titleRow1={'Solicitud'}
                    fieldRow1={'name'}
                    fieldSubtitle={'limitDate'}
                    textSubtitle={'subText'}
                    column2Status={window.innerWidth > 900}
                    fieldRow2={'numDocuments'}
                    titleRow2={'Cantidad documentos'}
                    styleCol2={'signatureReceivePanel-col-2'}
                    styleHeader2={'signatureReceivePanel-header-2'}
                    columnThree={window.innerWidth > 650}
                    fieldRow3={'numSigns'}
                    titleRow3={'Cantidad firmas'}
                    styleCol3={'signatureReceivePanel-col-3'}
                    styleHeader3={'signatureReceivePanel-header-3'}
                    onSelectedItem={setSelectedItem}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className='signatureReceivePanel-totalSigns-container-volumeSign'
                >
                  Total de solicitudes a firmar: {props.volumeSigns.length > +process.env.REACT_APP_QUANTITY_SIGNATURES
                    ? +process.env.REACT_APP_QUANTITY_SIGNATURES
                    : props.volumeSigns.length}
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className='signatureReceivePanel-inputs-container-volumeSign'
                >
                  <ValidationCodePure
                    data={props.nip}
                    setData={props.setNip}
                    validationLength={4}
                    title={'NIP de firma base'}
                    hide
                    autoFocusNIP
                  />
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className='signatureReceivePanel-buttons-container-volumeSign'
                  >
                    <ButtonHLPure
                      onClickBtn={() => props.showVolumeDialog(false)}
                      nameBtn={'Cancelar'}
                    />
                    <ButtonHLPure
                      disabled={props.nip.length !== 4}
                      onClickBtn={props.setVerifiedNip}
                      nameBtn={'Continuar'}
                      primary
                    />
                  </Grid>
                </Grid>
              </>
              : <div className='signatureReceivePanel-body-container'>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className='canvas-draw-container'
                >
                  <CanvasDraw
                    ref={pad}
                    className='canvas-draw-container'
                    loadTimeOffset={0}
                    lazyRadius={2}
                    brushRadius={2}
                    brushColor={'#000'}
                    catenaryColor={'#0a0302'}
                    gridColor={'rgba(150,150,150,0.17)'}
                    hideGrid
                    canvasWidth={'100%'}
                    canvasHeight={(isMobile) ? window.innerWidth / 2.09 : 300}
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className='signatureReceivePanel-buttons-container-volumeSign-verifiedNip'
                >
                  <ButtonHLPure
                    nameBtn='Regresar'
                    onClickBtn={() => props.returnVerifyNip()}
                  />
                  <ButtonHLPure
                    nameBtn='Firmar'
                    onClickBtn={() => props.signByVolume(isMobile)}
                    primary
                  />
                </Grid>
              </div>
            }
          </DialogFormHLPure>
        }
      </Container>
    </div>
  )
}

export { SignatureReceivePanelView as default }